/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {PaginationExampleDefault, PaginationExampleWithCallback, PaginationExampleCentered} from 'Docs/uilib/components/pagination/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Default pagination"
    }), "\n", _jsx(PaginationExampleDefault, {}), "\n", _jsx(_components.p, {
      children: "If you need to access methods provided by the render prop arguments."
    }), "\n", _jsx(PaginationExampleWithCallback, {}), "\n", _jsx(_components.h3, {
      children: "Centered Pagination with random delay"
    }), "\n", _jsx(_components.p, {
      children: "Note that we keep the height of the previous page. All pages can for sure have their own height."
    }), "\n", _jsx(PaginationExampleCentered, {}), "\n", _jsx(_components.h3, {
      children: "Infinity scroller demos"
    }), "\n", _jsxs(_components.p, {
      children: ["Check out ", _jsx(_components.a, {
        href: "/uilib/components/pagination/infinity-scroller",
        children: "demos for the Infinity Scroller"
      }), "."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
